import * as yup from "yup";

export const termsOfPaymentSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  type: yup.number().required("Type is required"),
  modeOfPaymentId: yup.string().when("paymentSchedules.0.step", {
    is: 5,
    then: yup.string("Enter a valid mode of payment").nullable(true),
    otherwise: yup
      .string("Enter a valid mode of payment")
      .typeError("Enter a valid mode of payment")
      .required("Enter a valid mode of payment"),
  }),
  intervalType: yup
    .number("Enter a valid interval type")
    .when(["type", "paymentSchedules.0.step"], {
      is: (type, paymentScheduleStep) =>
        type === 0 || paymentScheduleStep === 5,
      then: yup.number("Enter a valid interval type").nullable(true),
      otherwise: yup
        .number("Enter a valid interval type")
        .typeError("Enter a valid interval type")
        .required("Enter a valid interval type"),
    }),
  intervalValue: yup
    .number("Enter a valid interval value")
    .when(["type", "paymentSchedules.0.step"], {
      is: (type, paymentScheduleStep) =>
        type === 0 || paymentScheduleStep === 5,
      then: yup.number("Enter a valid interval value").nullable(),
      otherwise: yup
        .number("Enter a valid interval value")
        .positive("Enter positive value")
        .typeError("Enter a valid interval value")
        .required("Enter a valid interval value"),
    })
    .when("type", {
      is: 0,
      then: yup.number("Enter a valid interval value").nullable(true),
      otherwise: yup
        .number("Enter a valid interval value")
        .typeError("Enter a valid interval value")
        .required("Enter a valid interval value"),
    }),
  paymentSchedules: yup
    .array()
    .of(
      yup.object().shape({
        step: yup.number().min(0).required("Step is required").nullable(true),
        paymentType: yup.number().when("step", {
          is: 5,
          then: yup.number("Enter a valid payment type").min(0).nullable(true),
          otherwise: yup
            .number("Enter a valid payment type")
            .min(0)
            .required("Payment Type is required"),
        }),
        amountOrNumberOfSets: yup.number().when("step", {
          is: 5,
          then: yup.number("Enter a valid amount").nullable(true),
          otherwise: yup
            .number("Enter a valid amount")
            .positive("Enter positive amount")
            .typeError("Enter a valid amount")
            .min(0)
            .required("Amount Or Number of Payments is required"),
        }),
        intervalByDays: yup
          .number("Enter a valid interval")
          .positive("Enter positive value")
          .nullable(),
      })
    )
    .required(),
});
